import React from 'react'
import { IBreadcrumbSecondaryItem } from '../common/BreadcrumbSecondaryItem'
import BreadcrumbsSecondary from '../common/BreadcrumbsSecondary'

const UnpaidWagesBreadcrumbs = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const items: IBreadcrumbSecondaryItem[] = [
    {
      name: 'Home',
      url: govCMSHome,
      index: 1,
    },
    {
      name: 'About us',
      url: govCMSHome + '/about-us',
      index: 2,
    },
    {
      name: 'Community assistance',
      url: govCMSHome + '/about-us/community-assistance',
      index: 3,
    },
  ]
  return (
    <>
      <BreadcrumbsSecondary items={items} />
    </>
  )
}

export default UnpaidWagesBreadcrumbs
